import { combineReducers } from 'redux'
import notification from './features/notification'
import facilityList from './features/booking/FacilityList'
import facilityOrder from './features/booking/FacilityOrder'
import orderCreateInput from './features/booking/OrderCreateInput'
import orderCreateSuccess from './features/booking/OrderCreateSuccess'
import priceCalculate from './features/booking/PriceCalculate'
import customer from './features/customer'
import customerUpdate from './features/customer/UpdateCustomer'
import sagaStore from './features/sagaStore'
import auth from './features/auth'
import orders from './features/mypage/orders'
import language from './features/language'

export default combineReducers({
  notification,
  language,
  facilityList,
  facilityOrder,
  orderCreateInput,
  orderCreateSuccess,
  priceCalculate,
  customer,
  customerUpdate,
  sagaStore,
  auth,
  orders,
})
